import {UIGeneralServicesController} from '../../shared/scripts/UIGeneralServicesController'
import {UINotificationActionController} from '../../shared/scripts/notifications/UINotificationActionController'
import {UIMOnlineFriendController} from './ui_friends/UIMOnlineFriendController'
import {UIMManager} from './ui_html/UIMManager'

export class UIMGeneralServicesController extends UIGeneralServicesController {
    constructor(uiManager: UIMManager | undefined) {
        super()

        const notificationPanelController = uiManager?.mainpageController.headerController.notificationPanelController

        this.onlineFriendController = new UIMOnlineFriendController(notificationPanelController)
        if(!notificationPanelController) return
        this.notificationActionController = new UINotificationActionController(notificationPanelController)
    }

    init() {
        this.onlineFriendController?.init()
    }
}
